import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import MainLayout from './layouts/MainLayout'
import PrivateRoute from './components/PrivateRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Orders from './pages/Orders'
import Ledger from './pages/Ledger'
import Configs from './pages/Configs'
import SeedImport from './pages/SeedImport'

const App: React.FC = () => {
  return (
    <BrowserRouter basename="/admin">
      <Routes>
        {/* 登录页 - 公开 */}
        <Route path="/login" element={<Login />} />

        {/* 需要登录的路由 */}
        <Route element={<PrivateRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/ledger" element={<Ledger />} />

            {/* 需要超级管理员权限 */}
            <Route element={<PrivateRoute requiredRole="admin" />}>
              <Route path="/configs" element={<Configs />} />
              <Route path="/seed-import" element={<SeedImport />} />
            </Route>
          </Route>
        </Route>

        {/* 默认重定向 */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
